var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ModifyComparesion',[_c('template',{slot:"after"},[_c('TablePublic',{attrs:{"colLists":_vm.pickColLists,"tableData":_vm.currContent,"paginationFlag":false}})],1),_c('template',{slot:"before"},[_c('TablePublic',{attrs:{"colLists":_vm.pickColLists,"tableData":_vm.orignalContent,"paginationFlag":false}})],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }